import { parse as yamlParse } from 'yaml';
import { TpBitmap } from '../interfaces';

function mapMetaDataToBitmapObject(bitmapId: string, metadataObj: any): TpBitmap {
  return {
    id: bitmapId,
    name: metadataObj.displayName,
    description: metadataObj.description,
    canonicalTypeId: metadataObj.entityType,
    fileLocation: metadataObj.fileLocation,
    content: '',
    imageData: null,
    isPlotOverlay: metadataObj.plotOverlay ?? false,
    rectangle: metadataObj.coordinates ?? null,
    tags: metadataObj.tags ?? [],
  };
}

async function encodedBitmapContent(blob: Blob): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(<string>reader.result);
    reader.readAsDataURL(blob);
  });
}

async function base64ToHtmlImage(base64Content: string): Promise<HTMLImageElement> {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.src = base64Content;
  });
}

export async function fetchBitmapDataObject(dataObject: any): Promise<TpBitmap> {
  const metadataBlob = await fetch(dataObject.metadataUrl);
  const metadataText = await metadataBlob.text();
  const metadataObj = yamlParse(metadataText);
  const bitmap = mapMetaDataToBitmapObject(dataObject.tableId, metadataObj);

  const bitmapContent = await fetch(dataObject.publicUrl);
  const bitmapBlob = await bitmapContent.blob();

  bitmap.content = await encodedBitmapContent(bitmapBlob);
  if (bitmap.isPlotOverlay) {
    bitmap.imageData = await createImageBitmap(bitmapBlob);
  }

  return bitmap;
}
